import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {UserCarePlan} from "../../models/user-care-plan.model";
import {UserCarePlanService} from "../../providers/user-care-plan.service";
import {CountedUserCarePlanItem, UserCarePlanItem} from "../../models/user-care-plan-item.model";
import {CommonUtils} from "../../utils/common";
import {Router} from "@angular/router";
import {VetReservationService} from "../../providers/vet-reservation.service";

@Component({
  selector: 'app-user-care-plan-services-modal',
  templateUrl: './user-care-plan-services-modal.component.html',
  styleUrls: ['./user-care-plan-services-modal.component.scss'],
})
export class UserCarePlanServicesModalComponent implements OnInit {
  @Input() carePlanUUID: string;
  @Input() petName: string;
  @Input() colSize: number;
  isLoading: boolean;
  userCarePlan: UserCarePlan;
  userCarePlanItems: UserCarePlanItem[];
  visitCarePlanItems: UserCarePlanItem[];
  countedVisitCarePlanItems: CountedUserCarePlanItem[];

  constructor(private modalController: ModalController,
              private carePlanService: UserCarePlanService,
              private vetReservationService: VetReservationService,
              private commonUtils: CommonUtils,
              private router: Router) { }

  ngOnInit() {

    this.isLoading = true;
    try {
      this.carePlanService.getUserCarePlanByUUID(this.carePlanUUID).subscribe(userCarePlan => {
        this.isLoading = false;
        this.userCarePlan = userCarePlan;
        if (this.userCarePlan) {
          this.userCarePlanItems = this.userCarePlan.userCarePlanItems;
          this.visitCarePlanItems = this.getVisitCarePlanItems(this.userCarePlanItems);
          this.countedVisitCarePlanItems = this.groupCarePlanItems(this.visitCarePlanItems);
        }
      }, error => {
        this.isLoading = false;
      });
    } catch (e) {
      this.isLoading = false;

    }
  }

  onClose() {
    this.modalController.dismiss();
  }

  private getVisitCarePlanItems(userCarePlanItems: UserCarePlanItem[]) {
    return userCarePlanItems.filter(userCarePlanItem => userCarePlanItem.vetineoVisitTypeBundleUUID !== null);
  }


  private groupCarePlanItems(items: UserCarePlanItem[], countFieldName: string = 'carePlanServiceUUID'): CountedUserCarePlanItem[] {
    const groupedMap = new Map<string, CountedUserCarePlanItem>();

    for (const item of items) {
      const existing = groupedMap.get(item[countFieldName]);
      if (existing) {
        existing.count += 1;
        if (existing.realizationDate !== null && item.realizationDate === null) {
          groupedMap.set(item[countFieldName], {...item, count: existing.count});
        }
      } else {
        groupedMap.set(item[countFieldName], {...item, count: 1});
      }
    }

    return Array.from(groupedMap.values());
  }

  onRedirectToReservation($event: UserCarePlanItem) {
    this.router.navigate(['/vet-reservation'], {
      queryParams: {
        uuid: $event.vetReservationUUID
      },
      state: {
        from: 'carePlan',
        returnUrl: this.router.url
      }
    }).then(r => this.modalController.dismiss());
  }
}
